import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import { Button } from "../components/ui/button";
import { Checkbox } from "../components/ui/checkbox";

export default function Disclosure() {
  const { user, setUser } = useAuth();
  const nav = useNavigate();
  const [ack, setAck] = useState(false);
  const [saving, setSaving] = useState(false);

  const proceed = async () => {
    setSaving(true);
    try {
      const r = await api.post("/auth/disclosure");
      setUser({ ...user, disclosure_acknowledged_at: r.data.disclosure_acknowledged_at });
      nav("/app", { replace: true });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="dark min-h-screen bg-background text-foreground">
      <div className="mx-auto max-w-2xl px-6 py-12">
        <div className="mb-8 text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground">
          Before you start
        </div>
        <h1 className="font-heading text-2xl font-bold sm:text-3xl">Confidentiality disclosure</h1>

        <div className="mt-8 space-y-6 rounded-md border border-border p-6 text-sm leading-relaxed">
          <div>
            <div className="mb-2 font-heading font-semibold">Your agency can see:</div>
            <ul className="list-disc space-y-1 pl-5 text-muted-foreground">
              <li>That you completed training and when.</li>
              <li>That an SOS signal was sent — not what you said.</li>
            </ul>
          </div>
          <div>
            <div className="mb-2 font-heading font-semibold">Your agency cannot see:</div>
            <ul className="list-disc space-y-1 pl-5 text-muted-foreground">
              <li>Anything you said or chose during any scenario.</li>
              <li>Any score or zone you received.</li>
              <li>Anything from your SOS or EAP session.</li>
            </ul>
          </div>
          <p className="rounded-md border border-border p-4 text-sm">
            Everything else on this platform is 100% confidential.
          </p>
        </div>

        <div className="mt-6 flex items-center gap-3">
          <Checkbox
            id="ack"
            data-testid="disclosure-ack-checkbox"
            checked={ack}
            onCheckedChange={setAck}
          />
          <label htmlFor="ack" className="cursor-pointer text-sm">
            I have read and understood this disclosure.
          </label>
        </div>

        <Button
          data-testid="disclosure-continue-button"
          className="mt-6 w-full"
          disabled={!ack || saving}
          onClick={proceed}
          style={{ background: "hsl(var(--haruki-leaf))", color: "white" }}
        >
          {saving ? "Saving…" : "Continue to training"}
        </Button>
      </div>
    </div>
  );
}
